var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.563,25.436c-3.749-3.75-8.735-5.815-14.038-5.815c-5.304,0-10.289,2.065-14.039,5.815 c-7.264,7.264-7.711,18.802-1.344,26.593L25.584,67.588c-0.781,0.781-0.781,2.047,0,2.828c0.39,0.391,0.902,0.586,1.414,0.586 s1.024-0.195,1.414-0.586L43.97,54.858c3.536,2.896,7.924,4.471,12.555,4.471c5.303,0,10.289-2.065,14.038-5.815 C78.304,45.772,78.305,33.177,70.563,25.436z M67.735,50.686c-2.994,2.994-6.976,4.644-11.21,4.644 c-4.235,0-8.216-1.649-11.211-4.644c-6.181-6.182-6.181-16.24,0-22.421c2.995-2.994,6.976-4.643,11.211-4.643 c4.234,0,8.216,1.649,11.21,4.643C73.917,34.446,73.917,44.504,67.735,50.686z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.10273f8647ef8a07c2f53b7e1472dee4.svg";
export { ForwardRef as ReactComponent };